var _ref2, _ref3, _ref4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUploadPlaceholder = function SvgUploadPlaceholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 65,
      height: 64,
      viewBox: "0 0 65 64",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M17.2748 45.4111H48.9047C49.158 45.4183 49.4083 45.3542 49.6269 45.2262C49.8456 45.0981 50.0239 44.9113 50.1416 44.6868C50.2592 44.4624 50.3114 44.2094 50.2923 43.9567C50.2732 43.704 50.1836 43.4618 50.0335 43.2576L45.6705 37.3335C45.5566 37.1759 45.4101 37.0447 45.2409 36.9488C45.0717 36.8529 44.8839 36.7946 44.6901 36.7779C44.4964 36.7612 44.3013 36.7864 44.1182 36.8519C43.9351 36.9174 43.7683 37.0216 43.6291 37.1574L39.146 41.4243L28.7388 27.2946C28.6092 27.118 28.4387 26.9756 28.242 26.8795C28.0452 26.7834 27.8281 26.7364 27.6092 26.7427C27.3903 26.749 27.1762 26.8084 26.9853 26.9156C26.7944 27.0229 26.6324 27.1749 26.5132 27.3586L16.106 43.3216C15.9718 43.5283 15.8966 43.7677 15.8884 44.014C15.8803 44.2602 15.9396 44.504 16.0599 44.7191C16.1802 44.9341 16.3569 45.1123 16.571 45.2342C16.7851 45.3562 17.0285 45.4173 17.2748 45.4111Z",
      fill: "#D9D9D9"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M42.9309 27.4731C45.5527 27.4731 47.6782 25.3477 47.6782 22.7258C47.6782 20.1039 45.5527 17.9785 42.9309 17.9785C40.309 17.9785 38.1836 20.1039 38.1836 22.7258C38.1836 25.3477 40.309 27.4731 42.9309 27.4731Z",
      fill: "#D9D9D9"
    })), _ref4 || (_ref4 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 9.35254,
      y: 12.3711,
      width: 47.4793,
      height: 38.9828,
      rx: 3.05,
      stroke: "#D9D9D9",
      strokeWidth: 3.5
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgUploadPlaceholder, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/upload-placeholder.cce7d8e9.svg";
export { ForwardRef as ReactComponent };